import api,{ CrudRestApi } from "../../api";
import { DataEntry } from "models/nostradamus/administration/DataEntry";
import CamelCaseToKebabCase from "utils/helpers/CamelCaseToKebabCase";

const apiUrl = "admin/admin-data";
const rest = CrudRestApi(apiUrl, DataEntry);

const changePassword = async (data, appType) => {
    return api.put(
        `/${apiUrl}/change-${CamelCaseToKebabCase(appType)}-password`,
        data
    );
};

const createLoginToken = async (id) => {
    return api.post(`/${apiUrl}/create-login-token/${id}`);
};

const sendChangePasswordMail = async (id) => {
    return api.post(`/${apiUrl}/send-change-password-mail/${id}`);
};

const enableCustomerPortalUser = async (id) => {
    return api.put(`/${apiUrl}/mark-customer-portal-user-valid/${id}`);
};

const disableCustomerPortalUser = async (id) => {
    return api.post(`/${apiUrl}/mark-customer-portal-user-invalid/${id}`);
};

const displayCustomerApiCredentials = async (id) => {
    return api.get(`/${apiUrl}/customer-api-credentials/${id}`);
};

const getApiCredentials = async (id) => {
    return api.get(`/admin/api-credentials/admin/${id}/list`);
};

const createIntegrationApiCredentials = async (data) => {
    return api.post(`/${apiUrl}/create-integration-api-credentials`, data);
};

const syncPermissions = async (id) => {
    return api.post(`/${apiUrl}/sync-oauth/${id}`);
};

const syncPermissionsAllAdmins = async () => {
    return api.post(`/${apiUrl}/sync-admin-all`);
};

const DataEntryService = {
    ...rest,
    changePassword,
    createLoginToken,
    sendChangePasswordMail,
    enableCustomerPortalUser,
    disableCustomerPortalUser,
    displayCustomerApiCredentials,
    getApiCredentials,
    createIntegrationApiCredentials,
    syncPermissions,
    syncPermissionsAllAdmins,
};

export default DataEntryService;
